import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#a13d63',
    },
  },
});
